import { useState } from 'react'
import { errorMessage, useAuth } from '../lib/useAuth'
import { appleSignInEnabled } from '../lib/firebase'

interface Props {
  title?: string
  subtitle?: string
}

export default function SignIn({ title = 'Sign in', subtitle }: Props) {
  const { signInWithGoogle, signInWithApple, signInWithEmail, registerWithEmail } = useAuth()
  const [mode, setMode] = useState('signin')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function run(action: () => Promise<unknown>) {
    setBusy(true)
    setError(null)
    try {
      await action()
    } catch (e) {
      setError(errorMessage(e))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="card">
      <h2 style={{ marginTop: 0 }}>{mode === 'signin' ? title : 'Create an account'}</h2>
      <p style={{ color: 'var(--muted)', marginTop: 0 }}>
        {subtitle ?? 'Your account is what ties your subscription to every Mac you use it on.'}
      </p>

      {error && <p className="alert is-error">{error}</p>}

      <button className="btn btn-ghost btn-block" disabled={busy}
        onClick={() => run(signInWithGoogle)}>Continue with Google</button>
      {appleSignInEnabled && (
        <>
          <div style={{ height: '.6rem' }} />
          <button className="btn btn-ghost btn-block" disabled={busy}
            onClick={() => run(signInWithApple)}>Continue with Apple</button>
        </>
      )}

      <div className="divider">or</div>

      <form onSubmit={(e) => {
        e.preventDefault()
        run(() => (mode === 'signin' ? signInWithEmail(email, password) : registerWithEmail(email, password)))
      }}>
        <div className="field">
          <label htmlFor="email">Email</label>
          <input id="email" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="field">
          <label htmlFor="password">Password</label>
          <input id="password" type="password" required minLength={6}
            autoComplete={mode === 'signin' ? 'current-password' : 'new-password'}
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button className="btn btn-primary btn-block" type="submit" disabled={busy}>
          {mode === 'signin' ? 'Sign in' : 'Create account'}
        </button>
      </form>

      <p style={{ color: 'var(--muted)', fontSize: '.9rem', marginBottom: 0 }}>
        {mode === 'signin' ? 'No account yet? ' : 'Already have an account? '}
        <button className="btn" style={{ padding: 0, color: 'var(--accent)', background: 'none' }}
          onClick={() => { setMode(mode === 'signin' ? 'register' : 'signin'); setError(null) }}>
          {mode === 'signin' ? 'Create one' : 'Sign in'}
        </button>
      </p>
    </div>
  )
}
